import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import { IVariant } from 'base/interfaces/product';
import { useStore } from 'base/store';
import { getTagConfig, getTagElStyles } from 'mod/product/utils'
import { useTrans } from 'base/utils/i18n';

type IProps = {
    shownVariant: IVariant;
}

const ProductOffTag: React.FC<IProps> = (props) => {
    const { shownVariant } = props
    const { userStore } = useStore();
    const { t } = useTrans();

    const isInfoLoaded = userStore.isInfoLoaded();

    // tagTheme 直接取 flashsale（折扣）、nameTag, 与商品名称前面tag一致
    const tagConfig = getTagConfig('flashsale', 'nameTag')

    return !isInfoLoaded ? null : (
        <>
            {shownVariant?.discountPriceNumDisplay && (
                <div className={cn(styles['deal-discount-tag'])}>
                    <span
                        className={cn(
                            styles['value'],
                            'inline-block',
                        )}
                        style={getTagElStyles(tagConfig)?.titleStyle}
                    >
                        {
                            shownVariant.discountPriceNumDisplay.includes('%')
                                ? t('web_price_discount_off_upper', {discount: shownVariant.discountPriceNumDisplay})
                                : t('web_price_save_discount', {discount: shownVariant.discountPriceNumDisplay})
                        }
                    </span>
                </div>
            )}
        </>
    );
};

export default ProductOffTag